import { LitElement, css, html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement, property } from 'lit/decorators.js';

import { variables } from '../../variables';

@customElement('single-select-item')
export class SingleSelectItem extends LitElement {
  @property({ type: String })
  text = '';

  @property({ type: Boolean })
  selected = false;

  static override styles = [
    variables,
    css`
      .item {
        display: flex;
        padding-left: 32px;
        align-items: center;

        height: 46px;
        border-bottom: 1px solid var(--gray-300);
      }

      .selected {
        padding-left: 28px;
        background: var(--gray-200);
        border-left: 4px solid var(--green);
      }
    `,
  ];

  override render() {
    return html`<div
      class="item ${classMap({
        selected: this.selected,
      })}"
    >
      ${this.text}
    </div>`;
  }
}
